/**
 * How many CSL styles the catalog holds, written down.
 *
 * **Ask `getStyleCount()` (`src/lib/site-catalog.ts`) instead wherever you can.** That
 * one derives the number from `CITATION_STYLES` rather than storing it, which is the
 * whole point: a stored count is a fact with an expiry date, and this one expired
 * twice — fourteen dictionary strings in seventeen languages were still saying 10,832
 * when the catalog reached 10,834, and nothing failed.
 *
 * This file exists for the three callers that genuinely cannot derive it, because
 * `CITATION_STYLES` lives in a 4 MB generated module and no bundler can shake a
 * `.length` out of it:
 *
 * 1. **Client components** — `/compare`, the styles-hub browser. Importing the catalog
 *    would ship 4 MB of style metadata to the browser to print one number.
 * 2. **`/api/og`** — an edge route with a hard bundle limit. Same 4 MB, per render.
 * 3. **`src/data/glossary.ts`** — `site-catalog.ts` imports the glossary, so the
 *    glossary cannot import it back.
 *
 * The pin is only safe because `ai-surfaces.test.ts` asserts it equals
 * `CITATION_STYLES.length` and fails the build when the CSL repository grows. Do not
 * add a caller that could have used `getStyleCount()`.
 */
export const STYLE_COUNT = 10_834;
